import { GenericTableSchemaFormat } from "../common/genericTable/enum.genericTableSchemaFormat";
import { GenericTableDefinition } from "../common/genericTable/service.genericTable";

export const vatSettingGenericTable = {
  schema: {
    fields: {
      id: {
        format: GenericTableSchemaFormat.INTEGER,
        isPrimaryKey: true,
      },
      state: {
        format: GenericTableSchemaFormat.INTEGER,
      },
      description: {
        format: GenericTableSchemaFormat.STRING,
      },
      vatRate: {
        format: GenericTableSchemaFormat.INTEGER,
      },
      type: {
        format: GenericTableSchemaFormat.INTEGER,
      },
      natura: {
        format: GenericTableSchemaFormat.STRING,
      },
    },
  },
  getPath: (mandantId: number) => `/admin/mandants/${mandantId}/vatSettings/list/`,
} as const satisfies GenericTableDefinition;

export type VatSettingGenericTable = typeof vatSettingGenericTable;
